import { Controller } from '@hotwired/stimulus';
import { confirmDialog } from '../js/confirm_dialog';

// Verdict d'un rapport d'ESP face aux accessoires sous pression : dès qu'un de leurs points (groupe data-pressure) passe à NOK, le
// verdict (`field`) passe à NON et un message l'explique (repris dans la
// relecture) ; OUI reste possible après confirmation (`question` ; titre et
// libellé de Confirmer : data-title et data-commit du bouton OUI).
export default class extends Controller {
    static targets = ['message'];
    static values = { field: String, question: String };

    connect() {
        this.unsatisfying = this.pressureNok();
        this.messageTarget.hidden = !this.unsatisfying;
    }

    sync() {
        const unsatisfying = this.pressureNok();
        if (unsatisfying && !this.unsatisfying) this.decide('false');
        this.unsatisfying = unsatisfying;
        this.messageTarget.hidden = !unsatisfying;
    }

    // Clic sur OUI : sans NOK, le bouton agit seul ; sinon confirmation d'abord.
    async guard(event) {
        const radio = event.currentTarget;
        if (!this.pressureNok()) return;

        event.preventDefault();
        const submitter = { getAttribute: (name) => (name === 'title' ? radio.dataset.title : null), dataset: radio.dataset };
        if (await confirmDialog(this.questionValue, radio.form, submitter)) this.decide('true');
    }

    decide(value) {
        const radio = this.element.querySelector(`input[type="radio"][name="${CSS.escape(this.fieldValue)}"][value="${value}"]`);
        if (!radio || radio.checked) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    pressureNok() {
        return Boolean(this.element.querySelector('[data-pressure] input[type="radio"][value="no"]:checked'));
    }
}
